import { useEffect, useState } from 'react';
import { CommonButtonGroup } from '../../../../components/button/main';
import { CommonSelect } from '../../../../components/select';
import {
  getFirstManageSite,
  getNeedManageSites,
  getSiteText,
  isMultiManageSite,
} from '../../../../lib';
import { getValueText } from '../../../../lib/options';
import { CommonStatusStep } from '../../../../model/api-modules';
import { renderValidateStatusDot } from '../../lib/columns';

type SiteStatus = Record<string, CommonStatusStep>;
interface IProps {
  onChange?: (val: SiteStatus) => void;
  value?: SiteStatus;
  viewOnly?: boolean;
}

const options = [
  {
    value: CommonStatusStep.Pending,
    label: renderValidateStatusDot(CommonStatusStep.Pending),
  },
  {
    value: CommonStatusStep.Resolve,
    label: renderValidateStatusDot(CommonStatusStep.Resolve),
  },
];

export const MultiSiteStatus = (props: IProps) => {
  const { value, onChange, viewOnly } = props;
  const [siteStatus, setSiteStatus] = useState<SiteStatus>(value || {});

  useEffect(() => {
    setSiteStatus(value || {});
  }, [value]);

  if (viewOnly) {
    if (!isMultiManageSite()) {
      return <div>{getValueText(value?.[getFirstManageSite()], options)}</div>;
    }
    return (
      <div>
        {getNeedManageSites().map((site) => {
          return (
            <div>
              {`${getSiteText(site)}：`} {getValueText(value?.[site], options)}
            </div>
          );
        })}
      </div>
    );
  }
  const allSites = getNeedManageSites();

  return (
    <CommonButtonGroup>
      {allSites.map((site) => {
        return (
          <CommonSelect
            options={options}
            value={siteStatus[site]}
            prefix={getSiteText(site)}
            onChange={(status) => {
              const newStatus = {
                ...siteStatus,
                [site]: status,
              };
              setSiteStatus(newStatus);

              if (
                allSites.every(
                  (siteItem) => newStatus[siteItem] !== undefined
                ) ||
                !!value
              ) {
                onChange?.(newStatus);
              }
            }}
          ></CommonSelect>
        );
      })}
    </CommonButtonGroup>
  );
};
